import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import RNDrawerLayoutAndroid from "react-native-web/dist/exports/DrawerLayoutAndroid";
import RNFlatList from "react-native-web/dist/exports/FlatList";
import RNSwitch from "react-native-web/dist/exports/Switch";
import RNTextInput from "react-native-web/dist/exports/TextInput";
import RNScrollView from "react-native-web/dist/exports/ScrollView";
import createNativeWrapper from "./createNativeWrapper";
export var ScrollView = createNativeWrapper(RNScrollView, {
  disallowInterruption: true
});
export var Switch = createNativeWrapper(RNSwitch, {
  shouldCancelWhenOutside: false,
  shouldActivateOnStart: true,
  disallowInterruption: true
});
export var TextInput = createNativeWrapper(RNTextInput);
export var DrawerLayoutAndroid = createNativeWrapper(RNDrawerLayoutAndroid, {
  disallowInterruption: true
});
DrawerLayoutAndroid.positions = RNDrawerLayoutAndroid.positions;
export var FlatList = React.forwardRef(function (props, ref) {
  return React.createElement(RNFlatList, _extends({
    ref: ref
  }, props, {
    renderScrollComponent: function renderScrollComponent(scrollProps) {
      return React.createElement(ScrollView, scrollProps);
    }
  }));
});